import { useCapabilities } from "@/features/account/useCurrentUser";

export const API_KEY_SCOPES = ["completions", "harness"] as const;
export type ApiKeyScope = (typeof API_KEY_SCOPES)[number];

export const isApiKeyScope = (scope: string): scope is ApiKeyScope =>
  (API_KEY_SCOPES as readonly string[]).includes(scope);

export function useAvailableScopes(): ApiKeyScope[] {
  const { rallyEnabled } = useCapabilities();
  return rallyEnabled ? ["completions", "harness"] : ["completions"];
}
